import { render, staticRenderFns } from "./EmailRegister.vue?vue&type=template&id=3d6120ed&scoped=true"
import script from "./EmailRegister.vue?vue&type=script&lang=js"
export * from "./EmailRegister.vue?vue&type=script&lang=js"
import style0 from "./EmailRegister.vue?vue&type=style&index=0&id=3d6120ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6120ed",
  null
  
)

export default component.exports